import { addIndex, defaultTo, map, path, pipe } from 'ramda';
export const pathOr = (defaultValue, pathProps, obj) => pipe(path(pathProps), defaultTo(defaultValue))(obj);
export const mapIndexed = addIndex(map);